import Repository from '@/repositories/marketing'

export default {
    getList(config){
        return Repository.get(`/lists.json`,config)
    },
    getSegment(config){
        return Repository.get(`/segments.json`,config)
    },
    getJourney(config){
        return Repository.get(`/workflows.json`,config)
    }
}